import {
  setStroage,
  getStroage,
  getToken
} from '@/utils/auth.js'
import jq from 'jquery'
import Setting from '@/settings.js'

var {
  apiDomain,
  dicDomain,
  appId
} = Setting
const url = dicDomain + '/base/admin/dic/treeList'
import areaJson from '@/api/getArea'
// const authUrl = dicDomain + "/base/admin/permission/pemByUserAppPages?appId=" + appId
const authUrl = 'https://www.fastmock.site/mock/cf1802fc35660832efb2c75bb17a13c9/jdFront/menus'

//ajax同步请求
export function getAuthList(_url, _callback) {
  jq.ajax({
    type: 'GET',
    url: _url,
    async: false,
    data: {
      appId: appId
    },
    beforeSend: function (request) {
      request.setRequestHeader('access_token', getToken())
    },
    success: function (res) {
      _callback(res)
    },
    error: function (e) {
      console.log('this error is in function ' + e)
    }
  })
}

//用户切换获取操作权限字典
export function defaultAuth() {
  getAuthList(authUrl, function (res) {
    if (res.code == 0) {
      setStroage('authConfigList', JSON.stringify(res.data.pages))
    }
  })
}

//获取指定操作权限列表
export function getAuthFlag(_id) {
  var authArr = getStroage('authConfigList');
  var _result = false
  if (authArr) {
    authArr = JSON.parse(authArr)
    // console.log(dataArr)
    authArr.forEach(items => {
      if (items == _id) {
        _result = true
      }
    })
  } else {
    getAuthList(authUrl, function (res) {
      setStroage('authConfigList', JSON.stringify(res.data.pages))
      authArr = res.data.pages
      authArr.forEach(items => {
        if (items == _id) {
          _result = true
        }
      })
    })
  }
  return _result
}

//获取指定字典配置项 （字典id）
export function getDictList(_id) {
  var dataArr = getStroage('dictConfigList');
  var _result = [];
  var _getDictChild = function (_childArr) {
    if (_childArr.length > 0) {
      _childArr.forEach(item => {
        if (item.openStatus != '0') {
          _result.push(item)
        }
      })
    }
  }
  if (dataArr) {
    dataArr = JSON.parse(dataArr)
    // console.log(dataArr)
    dataArr.forEach(items => {
      if (items.id == _id) {
        // _result = items.child
        _getDictChild(items.child)
      }
    })
  }
  if (_result.length <= 0) {
    getAuthList(url, function (res) {
      setStroage('dictConfigList', JSON.stringify(res.data))
      dataArr = res.data
      dataArr.forEach(items => {
        if (items.id == _id) {
          // _result = items.child
          _getDictChild(items.child)
        }
      })
    })
  }
  return _result
}


export function title(_value) {
  const arr = []
  for (var i = 0; i < _value.length; i++) {
    arr.push({
      value: _value[i].percent,
      name: _value[i].name
    })
  }
  return arr
}

//数字转货币格式   传入要转换为货币格式的字段值
export function formatMoney(number) {
  var number = number || 0
  var places = 2
  // var symbol = "￥"
  var negative = number < 0 ? "-" : "",
    i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
    j = (j = i.length) > 3 ? j % 3 : 0
  return negative + (j ? i.substr(0, j) + "," : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ",") + (places ? "." + Math.abs(number - i).toFixed(places).slice(2) : "")
}

//数字转货币格式   传入要转换为货币格式的字段值 (保留一位小数)
export function formatFloatMoney(number) {
  var number = number || 0
  var places = 1
  // var symbol = "￥"
  var negative = number < 0 ? "-" : "",
    i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
    j = (j = i.length) > 3 ? j % 3 : 0
  return negative + (j ? i.substr(0, j) + "," : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ",") + (places ? "." + Math.abs(number - i).toFixed(places).slice(2) : "")
}

// 接口返回数据添加序号1.2.3....\
export function sortDataList(_list, pageNum) {
  if (_list.length === 0) {
    _list = []
  } else {
    for (var i = 0; i < _list.length; i++) {
      _list[i].sortNum = i + 1 + (parseInt(pageNum - 1)) * 10
    }
  }
  return _list
}

// 日期范围格式转换  2019-08-18T16:00:00.000Z 转换成格式2019-08-18
export function daterangeTrans(datetime) {
  function addDateZero(num) {
    return (num < 10 ? '0' + num : num)
  }

  var _type = typeof datetime
  if (_type == 'undefined' || _type == null || _type == '') {
    return ''
  } else {
    var d = new Date(datetime)
    var formatdatetime = d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate())
    // + ' ' + addDateZero(d.getHours()) + ':' + addDateZero(d.getMinutes()) + ':' + addDateZero(d.getSeconds())
    return formatdatetime
  }
}

// 日期范围格式转换  2019-08-18T16:00:00.000Z 转换成格式2019-08-18:00:00.00
export function dateTimeTrans(datetime) {
  function addDateZero(num) {
    return (num < 10 ? '0' + num : num)
  }

  var _type = typeof datetime
  if (_type == 'undefined' || _type == null || _type == '') {
    return ''
  } else {
    var d = new Date(datetime)
    var formatdatetime = d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate()) + ' ' + addDateZero(d.getHours()) + ':' + addDateZero(d.getMinutes()) + ':' + addDateZero(d.getSeconds())
    return formatdatetime
  }
}

// 状态类数据格式转换
export function statusTrans(_val, _list) {
  const _status = {
    icon: '',
    val: '--'
  }
  _list.forEach(item => {
    if (_val == item.id) {
      _status.icon = 'config-tag ' + item.icon
      _status.val = item.name
    }
  })
  return _status
}

// 系统id转换名称
export function nameTrans(_val, _list) {
  const _status = {
    val: '--'
  }
  for (var i = 0; i < _list.length; i++) {
    if (_val == _list[i].id) {
      _status.val = _list[i].name
    }
  }
  return _status
}

// 空字段转换
export function emptyTrans(_val) {
  var resultStr = _val
  if (_val == '' || _val == 'undefined' || _val == null || _val == '') {
    resultStr = '--'
  } else {
    resultStr = _val
  }
  return resultStr
}

// 机构数据格式转换
export function orgTrans(_val, _list) {
  const _status = {
    val: '--'
  }
  _list.forEach(item => {
    if (_val == item.id) {
      _status.val = item.name
    }
  })
  return _status
}

export function formatDate(_val) {
  if (!_val) {
    return null
  }
  _val = _val.split(" ");
  if ((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))) {
    _val = _val[0].replace(/'-'/g, '/')
  }
  if (_val) {
    var date = new Date(_val);
    const year = date.getFullYear()
    var month;
    if ((date.getMonth() + 1) < 10) {
      month = '0' + (date.getMonth() + 1)
    } else {
      month = date.getMonth() + 1
    }
    var day;
    if (date.getDate() < 10) {
      day = '0' + date.getDate()
    } else {
      day = date.getDate()
    }
    const time = year + '-' + month + '-' + day

    return time
  }

}

//关联角色数据格式转换
export function roleTrans(_val, _list) {
  const arr = _val.split(",")
  const arr1 = []
  for (var i = 0; i < arr.length; i++) {
    for (var j = 0; j < _list.length; j++) {
      if (arr[i] == _list[j].id) {
        arr1.push(_list[j].name)
      }
    }
  }

  return arr1.toString()
}

//当前页求和
export function countCurrentPage(_key, _list) {
  var _result = 0
  if (_list && _list.length > 0) {
    _list.forEach(items => {
      if (items[_key]) {
        _result = _result + items[_key]
      }
    })
  }
  return _result
}

//获取今天日期
export function getToday() {
  var _result = null
  var time = (new Date).getTime();
  var yesterday = new Date(time);
  var month = yesterday.getMonth();
  var day = yesterday.getDate();
  _result = yesterday.getFullYear() + "年" + (yesterday.getMonth() + 1 > 9 ? (yesterday.getMonth() + 1) : "0" + (yesterday.getMonth() + 1)) + "月" + (yesterday.getDate() > 9 ? (yesterday.getDate()) : "0" + (yesterday.getDate())) + "日";
  return _result
}

//流量主区间转换数据 date time  => date
export function areaDateTrans(_date1, _date2, isTime) {
  var _result = "--";
  if (_date1) {
    if (_date2) {
      if (isTime) {
        _date1 = _date1.split(" ");
        _date2 = _date2.split(" ");
        _date1 = _date1[0]
        _date2 = _date2[0]
      }
      _result = _date1 + '至' + _date2
    } else {
      if (isTime) {
        _date1 = _date1.split(" ");
        _date1 = _date1[0]
      }
      _result = _date1 + '至今'
    }
  }
  return _result
}

export function getAddress(_p, _c, _a) {
  var _list = areaJson.data.items
  var _result = "";
  _list.forEach(items => {
    if (items.region_code == _p) {
      _result += items.region_name
      items.children.forEach(subItem => {
        if (subItem.region_code == _c) {
          _result += subItem.region_name
          subItem.children.forEach(thItem => {
            if (thItem.region_code == _a) {
              _result += thItem.region_name
            }
          })
        }
      })
    }
  })
  return _result
}
